/** @jsx h */
import { h } from 'preact'

const Arrow = props => (
  <svg width={18} height={18} {...props} class='Action-arrow'>
    <g fill='none' fillRule='evenodd'>
      <path d='M0 0h18v18H0z' />
      <path
        stroke='currentColor'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth={2}
        d='M2 9h14'
      />
      <path
        stroke='currentColor'
        strokeLinecap='round'
        strokeWidth={2}
        d='M10 3l6 6-6 6'
      />
    </g>
  </svg>
)

export default Arrow
